// Every backend URL the client calls. Paths are relative to API_BASE;
// build a full URL (for <img src> or XHR) with apiUrl().

export const API_BASE = process.env.REACT_APP_API_URL || '';

export const apiUrl = (path) => `${API_BASE}${path}`;

const enc = encodeURIComponent;

export const ENDPOINTS = {
  // Admin auth
  AUTH_LOGIN: 'auth/login',
  AUTH_RESET_PASSWORD: "auth/reset-password",
  AUTH_LOGOUT: 'auth/logout',
  AUTH_VERIFY: 'auth/verify',
  AUTH_UPDATE_PASSWORD: 'auth/update-password',
  AUTH_FORGOT_PASSWORD: 'auth/forgot-password',
  AUTH_VERIFY_RESET_OTP: 'auth/verify-reset-otp',
  AUTH_RESET_PASSWORD: 'auth/reset-password',

  // Dashboard
  DASHBOARD: 'dashboard',
  DASHBOARD_STATS: 'dashboard/stats',
  DASHBOARD_EXPORT: 'dashboard/export',
  DASHBOARD_RECORD: (token) => `dashboard/${enc(token)}`,
  DELETE_VERIFICATION: (token) => `delete-verification/${enc(token)}`,
  INVALIDATE_LINK: (token) => `invalidate-link/${enc(token)}`,
  PUBLISH_RENTSECURE: (token) => `publish-rentsecure/${enc(token)}`,
  MARK_DOWNLOADED: (token) => `mark-downloaded/${enc(token)}`,
  UPDATE_VERIFICATION: (token) => `update-verification/${enc(token)}`,
  UPDATE_GEO: (token) => `update-geo/${enc(token)}`,
  RESEND_LINK: 'resend-link',
  CONVERT_PDF: 'convert-pdf',

  // Send link
  CASE_DETAILS: 'case-details',
  CREATE_LINK: 'create-link',

  // Candidate verification page
  VERIFY_LINK: (token) => `verify/${enc(token)}`,
  COMPONENT_DETAILS: 'component-details',
  SUBMIT_VERIFICATION: (token) => `submit/${enc(token)}`,

  // Geo and media
  GEOCODE_ADDRESS: 'geocode-address',
  REVERSE_GEOCODE: 'reverse-geocode',
  STATIC_MAP: 'static-map',
  IMAGE_PROXY: 'image-proxy',
};
